
import Vue from 'vue'
/**
 * 日期格式化
 * eg:{{data | wq_capitalize('yyyy-MM-dd hh:mm')}}
 *  **/
Vue.filter('wq_capitalize', (value, f) => {
  if(!value) return '';
  var elem = new Date(value);
  var o ={
    "M+" : elem.getMonth()+1, //月
    "d+" : elem.getDate(),    //d日
    "h+" : elem.getHours(),   //时
    "m+" : elem.getMinutes(), //分
    "s+" : elem.getSeconds(), //秒
    "q+" : Math.floor((elem.getMonth()+3)/3),
    "S" : elem.getMilliseconds()
  }
  if(/(y+)/.test(f)) f=f.replace(RegExp.$1,(elem.getFullYear()+"").substr(4 - RegExp.$1.length));
  for(var k in o)
    if(new RegExp("("+ k +")").test(f))f = f.replace(RegExp.$1,RegExp.$1.length==1 ? o[k] : ("00"+ o[k]).substr((""+ o[k]).length));return f
});
Vue.filter('ellipsisEight', (value) => {
  if (!value) return ''
  if (escape(value).indexOf("%u") < 0) {
    // console.log( "不全是中文" );
    if (value.length > 16) {
      return value.substring(0, 15) + '...'
    } else {
      return value
    }
  } else {
    // console.log( "全是中文" );
    if (value.length > 8) {
      return value.substring(0, 8) + '...'
    } else {
      return value
    }
  }
});
/**
 * 时间单位转换
 * eg:
 *  **/
Vue.filter('timeFilter', (value) => {
  if(!value) return '-';
  if(value =='year'){
    return '年'
  } else if(value == 'month'){
    return '月'
  } else if(value == 'day'){
    return '日'
  } else {
    return '-'
  }
});
/**
 * 通知类型
 * eg:
 *  **/
Vue.filter('NotificationType', (value) => {
  if(!value) return '';
  if(value =='all'){
    return '全部系统'
  }else if(value == 'ty'){
    return '轨迹追踪系统'
  }else if(value == 'vat'){
    return 'VAT注册/申报系统'
  }else if(value == 'erp'){
    return 'ERP系统'
  }
});
export default {}



// WEBPACK FOOTER //
// ./src/public/filters.js